(ns app.front.view.reset-password.core
  (:require [app.front.view.not-found :as not-found]
            [app.front.view.reset-password.reset :as reset]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(rf/reg-event-db
  ::init
  (fn [db [_ token]]
    (-> db
        (assoc :session/user nil)
        (assoc ::user-data {:user/token token}))))


(rf/reg-sub
  ::user-data
  (fn [db [_ path]]
    (let [doc (::user-data db)]
      (if path (get-in doc path) doc))))


(defn new-password-subview []
  (if (nil? (<sub [::user-data [:user/token]]))
    [not-found/not-found-view]
    [reset/view (<sub [::user-data])]))


(def new-password-view
  {:name        :reset-password
   :view        new-password-subview
   :public?     true
   :parameters  {:path {:token s/Str}}
   :controllers [{:parameters {:path [:token]}
                  :start      (fn [{p :path}]
                                (when (some? (:token p))
                                  (rf/dispatch [::init (:token p)])))}]})
